"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.catchAndNotify = exports.showNotification = void 0;
const showNotification = (type, content, options) => {
    var _a, _b;
    if (!((_b = (_a = window.sharedHostGateway) === null || _a === void 0 ? void 0 : _a.notifications) === null || _b === void 0 ? void 0 : _b.showNotification)) {
        throw new Error('SharedHostGateway Error: notifications are not registered');
    }
    window.sharedHostGateway.notifications.showNotification(type, content, options);
};
exports.showNotification = showNotification;
const catchAndNotify = (error) => {
    var _a, _b;
    if (!((_b = (_a = window.sharedHostGateway) === null || _a === void 0 ? void 0 : _a.notifications) === null || _b === void 0 ? void 0 : _b.catchAndNotify)) {
        throw new Error('SharedHostGateway Error: error notifications are not registered');
    }
    window.sharedHostGateway.notifications.catchAndNotify(error);
};
exports.catchAndNotify = catchAndNotify;
